import { Component, Host, h, Prop } from '@stencil/core';
import { HTMLAnchorElementTarget } from '../../utils/helpers';

@Component({
  tag: 'vds-footer',
  styleUrl: 'vds-footer.scss',
  shadow: true,
})
export class VdsFooter {

  /**
   * Headline
   */
  @Prop() headline: string;

  /**
   * Top link text
   */
  @Prop() topLinkText: string;

  /**
   * Top link href
   */
  @Prop() topLinkHref: string;

  /**
   * Top link target
   */
  @Prop() topLinkTarget: HTMLAnchorElementTarget = '_blank';

  /**
   * Copyright
   */
  @Prop() copyright: string;

  render() {
    const { headline, topLinkText, topLinkHref, topLinkTarget, copyright } = this;
    return (
      <Host>
        <div class="lg:mt-[100px] mt-[70px] md:pb-[20px] pb-[10px] border-b-8 border-yellow bg-white">
          <div class="flow-root box-content max-w-[1200px] mx-auto px-[30px]">
            <div class="mb-[85px] flex flex-wrap items-center">
              <h4 class="uppercase mr-[30px] mb-[20px] sm:mb-0 text-h4-desktop text-grey font-heavy">
                { headline }
              </h4>
              <slot name="cta"></slot>
            </div>
            <vds-interactive-link href={ topLinkHref } target={ topLinkTarget } class="w-fit font-bold text-footer-mobile md:text-sidebar-mobile text-center md:text-left mx-auto md:mx-0 mb-4">
              { topLinkText }
            </vds-interactive-link>
            <div class="flex flex-wrap items-center">
              <div class="w-full max-w-full box-border md:text-left text-center md:order-first order-last">
                <a href="#" class="relative text-grey-dark text-center md:text-footer-desktop text-footer-mobile mx-[10px] md:mx-0 pointer-events-none">
                  { copyright }
                </a>
              </div>
              <div class="w-full max-w-full box-border flex flex-wrap items-center justify-between">
                <div class="w-full max-w-full md:w-auto box-border flex flex-wrap mb-[25px] md:mb-0 justify-center">
                  <slot name="social-media-items"></slot>
                </div>
                <div class="flex flex-wrap md:order-first md:justify-start justify-center flex-1">
                  <slot name="footer-links"></slot>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Host>
    );
  }

}
